import { useGetAddress } from '../useStorage'

import Oracle from '@/contracts/Oracle'
import Staking from '@/contracts/Staking'
import { Interface } from 'ethers'

const useStakingContract = () => {
  const { data } = useGetAddress('Staking')

  const contractInterface = new Interface(Staking)

  return {
    address: data,
    contractInterface,
    abi: Staking,
  }
}

export default useStakingContract

export const useOracleContract = () => {
  const { data } = useGetAddress('Oracle')

  const contractInterface = new Interface(Oracle)

  return {
    address: data,
    contractInterface,
    abi: Oracle,
  }
}
